/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */
require('bootstrap')
import { Lang } from 'laravel-vue-lang';
import UniqueId from 'vue-unique-id';
import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue';
import VueLodash from 'vue-lodash'
import lodash from 'lodash'

import { utils } from './utils'


window.introJs = require('intro.js');

window.Vue = require('vue');

Vue.use(BootstrapVue);
Vue.use(BootstrapVueIcons);
Vue.use(Lang);
Vue.use(UniqueId);
Vue.use(VueLodash, { lodash: lodash })


Vue.prototype.$utils = utils
Vue.prototype.$imgPath = '../../images/'

window.Vue = require('vue');
window.axios = require('axios');
/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */
// const files = require.context('./', true, /\.vue$/i)
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))
Vue.component("test-vue", require("./components/test/Test.vue").default);
// Vue.component("test2-vue", require("./components/test/Test2.vue").default);
Vue.component("security-chart", require("./components/securities/SecurityChart.vue").default);

Vue.component('investment-form', require('./components/investments/InvestmentForm.vue').default);
Vue.component('periodicity-form', require('./components/investments/PeriodicityForm.vue').default);
Vue.component('dollar-form', require('./components/investments/DollarForm.vue').default);
//Vue.component('dollar-regular-form', require('./components/investments/DollarRegularForm.vue').default);
Vue.component('dollar-isin-form', require('./components/investments/DollarIsinForm.vue').default);
Vue.component('dollar-capital-form', require('./components/investments/DollarCapitalForm.vue').default);

Vue.component('sector-chart', require('./components/home/SectorChart.vue').default);
Vue.component('capital-chart', require('./components/home/CapitalChart.vue').default);
Vue.component('arbitration-form', require('./components/home/ArbitrationForm.vue').default);
Vue.component('arbitration-shares-form', require('./components/home/ArbitrationSharesForm.vue').default);
Vue.component('send-form', require('./components/home/SendForm.vue').default);
Vue.component('live-portfolio-form', require('./components/home/LivePortfolioForm.vue').default);
Vue.component('user-list-form', require('./components/home/UserList.vue').default);

Vue.component('capital-model', require('./components/model/CapitalModel.vue').default);
Vue.component('sector-bar', require('./components/model/SectorBar.vue').default);
Vue.component('arbitration-model-form', require('./components/model/ArbitrationModelForm.vue').default);

Vue.component('lookthrough-form', require('./components/scanner/LookThrough.vue').default);
Vue.component('lookthrough-details-form', require('./components/scanner/DetailsForm.vue').default);
Vue.component('credentials-form', require('./components/scanner/CredentialsForm.vue').default);
Vue.component('scanner-form', require('./components/scanner/ResultScanner.vue').default);
Vue.component('scanner-esg-form', require('./components/scanner/ESGScanner.vue').default);
Vue.component('xray-sectors', require('./components/scanner/xray-sectors.vue').default);
Vue.component('xray-bars', require('./components/scanner/xray-bars.vue').default);
Vue.component('capital-xray', require('./components/scanner/capital-xray.vue').default);
Vue.component('scanner-reco-form', require('./components/scanner/Recommendation.vue').default);
Vue.component('scanner-recoclient-form', require('./components/scanner/RecommendationsClient.vue').default);
Vue.component('platform-comparison-form', require('./components/scanner/PlatformComparison.vue').default);
Vue.component('platform-comparison-optimised-form', require('./components/scanner/PlatformComparisonOptimised.vue').default);
Vue.component('cppi-new-form', require('./components/scanner/CPPINewForm.vue').default);
Vue.component('cppi-overview-form', require('./components/scanner/CPPIOverviewForm.vue').default);
Vue.component('cppi-simulation-form', require('./components/scanner/CPPISimulationForm.vue').default);
Vue.component('esg-best-form', require('./components/scanner/ESGBestForm.vue').default);
Vue.component('esg-best-fund-form', require('./components/scanner/ESGBestFundForm.vue').default);
Vue.component('security-ranking-form', require('./components/scanner/SecurityRankingForm.vue').default);
Vue.component('esg-contract-platform-form', require('./components/scanner/ESGContractPlatformForm.vue').default);
Vue.component('first-portfolio-select-form', require('./components/scanner/FirstPorfolioSelectForm.vue').default);
Vue.component('optimiser-bar-form', require('./components/scanner/OptimiserBarForm.vue').default);
Vue.component('optimiser-chart-form', require('./components/scanner/OptimiserChartForm.vue').default);
Vue.component('affiliation-form', require('./components/scanner/AffiliationForm.vue').default);
Vue.component('pilot-form', require('./components/scanner/PilotForm.vue').default);
Vue.component('esg-diagnostic-form', require('./components/scanner/ESGDiagnostic.vue').default);
Vue.component('fees-diagnostic-form', require('./components/scanner/FeesDiagnostic.vue').default);
Vue.component('risks-diagnostic-form', require('./components/scanner/RisksDiagnosticForm.vue').default);
Vue.component('main-dashboard-composition-form', require('./components/scanner/MainDashBoardComposition.vue').default);

Vue.component('questionnaire-form', require('./components/scanner/Questionnaire/Index.vue').default);

Vue.component('retail-follow-form', require('./components/scanner/RetailFollowForm.vue').default);

Vue.component('simulation-form', require('./components/public/Simulation.vue').default);
Vue.component('flat-form', require('./components/public/SimulationFlat.vue').default);
Vue.component('allocation-form', require('./components/public/AllocationMyfo.vue').default);
Vue.component('blog-vue', require('./components/public/Blog.vue').default);
Vue.component('mf_accueil', require('./components/home/accueil/Index.vue').default);
Vue.component('mf_offrepro', require('./components/home/offrePro/Index.vue').default);
Vue.component('mf_lateam', require('./components/home/teamMyfo/Index.vue').default);
Vue.component('mf_fp_select', require('./components/scanner/firstPortfolio/select/Index.vue').default);
Vue.component('mf_fp_optimizer', require('./components/scanner/firstPortfolio/optimizer/Index.vue').default);
Vue.component('mf_fp_optimizer_form', require('./components/scanner/firstPortfolio/optimizer/comps/InscriptionForm.vue').default);
Vue.component('mf_user_rayonx', require('./components/scanner/rayonX/Index.vue').default);
Vue.component('mf_user_optimiseurdefrais', require('./components/scanner/result_not_optim/Index.vue').default);
Vue.component('mf_user_scannercredential', require('./components/scanner/scannerCredential/Index.vue').default);
Vue.component('mf_user_maindashboard', require('./components/scanner/mainDashboard/Index.vue').default);
Vue.component('mf_user_visionlaser', require('./components/scanner/visionLaser/Index.vue').default);
Vue.component('mf_user_questionnaire_store', require('./components/scanner/questionnaireStore/Index.vue').default);
Vue.component("mf_star_rating", require("./components/utils/StarRating.vue").default);

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */
// Register the plugin
Vue.use(Lang);

const app = new Vue({
    el: '#app',
});
window.AOS = require('aos');
window.addEventListener('load', AOS.refresh)
AOS.init({
    easing: 'ease-out-back',
    duration: 1000
});

Vue.use(require('bootstrap-vue'));


